import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/about.scss";

const principles = [
  {
    title: "Purposeful form",
    text: "Every line is considered. Proportion, movement, and utility shape pieces designed to live beyond a single season.",
  },
  {
    title: "Material intelligence",
    text: "Natural tactility meets precise construction, allowing each fabric and finish to retain its own character.",
  },
  {
    title: "Quiet confidence",
    text: "The collection favors presence over display: a wardrobe defined by clarity, ease, and an independent point of view.",
  },
];

function About() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="about-page">
      <section className="about-page__intro" aria-labelledby="about-title">
        <p className="about-page__eyebrow">The house</p>
        <h1 id="about-title">{siteConfig.brandName}</h1>
        <p className="about-page__lead">{siteConfig.description}</p>
      </section>

      <section className="about-page__image-pair" aria-label="Collection study">
        <figure>
          <img
            src="/main/home-women.png"
            alt="Woman wearing a precisely cut contemporary look"
            loading="eager"
          />
          <figcaption>Womenswear / Study in proportion</figcaption>
        </figure>
        <figure>
          <img
            src="/main/home-men.png"
            alt="Man wearing a restrained modern tailored look"
            loading="eager"
          />
          <figcaption>Menswear / Study in movement</figcaption>
        </figure>
      </section>

      <section className="about-page__statement" aria-labelledby="approach-title">
        <div className="about-page__statement-heading">
          <p className="about-page__eyebrow">Our approach</p>
          <h2 id="approach-title">Clarity is an active choice.</h2>
        </div>
        <p className="about-page__statement-copy">
          We create through reduction: removing the expected until only the
          essential remains. The result is not austerity, but space for the
          wearer. Each collection develops a continuing language of exact
          tailoring, tactile materials, and subtle contrast.
        </p>
      </section>

      <section className="about-page__principles" aria-label="Design principles">
        {principles.map((principle, index) => (
          <article key={principle.title}>
            <span aria-hidden="true">0{index + 1}</span>
            <h3>{principle.title}</h3>
            <p>{principle.text}</p>
          </article>
        ))}
      </section>

      <section className="about-page__closing" aria-labelledby="about-closing-title">
        <p className="about-page__eyebrow">The collection</p>
        <h2 id="about-closing-title">A wardrobe for the present.</h2>
        <Link to="/shop" onClick={toTop}>
          Explore all pieces
        </Link>
      </section>
    </main>
  );
}

export default About;
